"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionService = void 0;
const SubscriptionServiceLive_1 = require("./SubscriptionServiceLive");
const SubscriptionServiceStub_1 = require("./SubscriptionServiceStub");
class SubscriptionService {
    static create(stub = false) {
        if (stub) {
            return new SubscriptionServiceStub_1.SubscriptionServiceStub();
        }
        return new SubscriptionServiceLive_1.SubscriptionServiceLive();
    }
}
exports.SubscriptionService = SubscriptionService;
//# sourceMappingURL=SubscriptionService.js.map